import { integrationsQueryKeys } from './integrationsQueryKeys.js';

const integrationsQueryPredicates = {
  integrationByExternalIdAll: (query) => {
    const integrationKey = integrationsQueryKeys.integrationByExternalId("");
    return query.queryKey[0] === integrationKey[0];
  },
  integrationByExternalId: (query, id) => {
    const integrationKey = integrationsQueryKeys.integrationByExternalId(id);
    return query.queryKey[0] === integrationKey[0] && query.queryKey[1] === integrationKey[1];
  },
  integrationsList: (query) => {
    return query.queryKey[0] === integrationsQueryKeys.list()[0];
  }
};

export { integrationsQueryPredicates };
//# sourceMappingURL=integrationsQueryPredicates.js.map
